<template>
    <div>
        <h5 class="mb-4">
            <strong>Gestión de pictogramas</strong>
        </h5>

        <b-row class="mb-3">
            <b-col md="3">
                <b-form-group label="Pictograma">
                    <b-form-input v-model="filterPictogramsSga.name" type="text" placeholder="Buscar por nombre"
                        class="form-control" />
                </b-form-group>
            </b-col>

            <b-col md="3" class="mt-auto">
                <b-form-group>
                    <b-button variant="primary" @click="searchPictogramsSga">
                        <i class="fa fa-search"></i>
                        <span class="ml-1" v-text="'Buscar'"></span>
                    </b-button>
                    <b-button class="mx-1" @click="clearFilter">
                        <i class="fa fa-eraser"></i>
                        <span class="ml-1" v-text="'Limpiar'"></span>
                    </b-button>
                </b-form-group>
            </b-col>

            <b-col md="12" class="mt-4 d-flex justify-content-end align-items-center">
                <b-form-group>
                    <el-tooltip effect="light" placement="top" popper-class="py-1 px-2" content="Sincronizar idiomas para los nombres de los pictogramas">
                        <b-button variant="warning" class="ml-1" @click="asyncLanguagesPictogramsSga">
                            <i class="fa fa-language" aria-hidden="true"></i>
                        </b-button>
                    </el-tooltip>
                    <b-button variant="primary" @click="createPictogram" class="ml-1">
                        <i class="fa fa-plus" />
                        <span class="ml-1" v-text="'Nuevo pictograma'" />
                    </b-button>
                </b-form-group>
            </b-col>

            <b-modal id="modal_create_pictograms" size="md" hide-footer no-close-on-esc no-close-on-backdrop
                hide-header-close>
                <template #modal-title>
                    {{ action === 'edit' ? 'Editar' : 'Registrar nuevo' }} pictograma
                </template>
                <formPictograms />
            </b-modal>

            <b-col md="12">
                <b-form-group>
                    <b-table :items="pictogramsSga.data" :fields="fields" responsive striped hover bordered
                        thead-tr-class="table-active" show-empty thead-class="table-active"
                        empty-text="No hay resultados para mostrar.">
                        <template v-slot:cell(image)="data">
                            <img :src="data.item.image" alt="pictograma" width="80" />
                        </template>
                        <template #cell(is_active)="data">
                            <b-badge :variant="data.item.is_active ? 'success' : 'danger'">
                                {{data.item.is_active ? 'ACTIVO' : 'INACTIVO'}}
                            </b-badge>
                        </template>
                        <template #cell(actions)="data">
                            <div class="d-flex justify-content-lg-center justify-content-between flex-wrap flex-nowrap">
                                <el-tooltip content="Editar" placement="top" effect="light">
                                    <el-button type="text" class="text-primary" @click="editPictogram(data.item)">
                                        <i class="fa fa-edit fa-lg"></i>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip class="ml-2" :content="data.item.is_active ? 'Inactivar' : 'Activar'"
                                    placement="top" effect="light">
                                    <el-button type="text" @click="changeStatus(data.item.id)"
                                        :class="`${!data.item.is_active ? 'text-success' : 'text-danger'}`">
                                        <i :class="`fa fa-lg ${!data.item.is_active ? 'fa-check' : 'fa-close'}`"></i>
                                    </el-button>
                                </el-tooltip>
                            </div>
                        </template>
                    </b-table>
                </b-form-group>
            </b-col>

            <b-col md="12">
                <b-form-group>
                    <div class="d-flex justify-content-end align-items-center pr-4">
                        <el-pagination style="max-width: 100%" v-model="filterPictogramsSga.page"
                            :total="filterPictogramsSga.total" :current-page="filterPictogramsSga.page"
                            :page-size="filterPictogramsSga.per_page" @size-change="afterChangeSizePagination"
                            @current-change="afterChangePagePagination" :page-sizes="[10, 30, 50, 100]"
                            layout="total, sizes, prev, pager, next" />
                    </div>
                </b-form-group>
            </b-col>

        </b-row>

    </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import formPictograms from './FormPictograms.vue';
export default {
    name: 'pictograms',
    components: {
        formPictograms,
    },
    data() {
        return {
            fields: [
                {
                    key: "name",
                    label: "Nombre",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "image",
                    label: "Imagen",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "is_active",
                    label: "Estado",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "user.name",
                    label: "Creado por",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "actions",
                    label: "Acciones",
                    sortable: false,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
            ],
        };
    },

    computed: {
        ...mapState('sgaPictograms', ['pictogramsSga', 'action', 'filterPictogramsSga']),
    },

    methods: {
        ...mapActions('sgaPictograms', ['getPictogramsSga', 'changeStatusPictogramSga', 'showPictogramSga', 'asyncLanguagesPictogramsSga']),
        ...mapMutations('sgaPictograms', ['setActionPictogramSga', 'setDefaultFilterSgaPictograms', 'loadAfterChangeSizePagination',
            'loadAfterChangePagePagination']),

        createPictogram() {
            this.setActionPictogramSga('create');
            this.$bvModal.show('modal_create_pictograms');
        },

        async clearFilter() {
            this.setDefaultFilterSgaPictograms();
            await this.getPictogramsSga();
        },

        async afterChangeSizePagination(size) {
            this.loadAfterChangeSizePagination(size);
            await this.getPictogramsSga();
        },

        async afterChangePagePagination(page) {
            this.loadAfterChangePagePagination(page);
            await this.getPictogramsSga();
        },

        async changeStatus(id) {
            await this.changeStatusPictogramSga(id);
            await this.getPictogramsSga();
        },

        editPictogram(language) {
            this.showPictogramSga(language.id);
            this.setActionPictogramSga('edit');
            this.$bvModal.show('modal_create_pictograms');
        },

        async searchPictogramsSga() {
            await this.getPictogramsSga(true);
        },
    },
};
</script>
